import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/useAuth';
import { LoadingSpinner } from '../components/common/LoadingSpinner';
import { BrandMark } from '../components/common/BrandMark';

export const LoginPage: React.FC = () => {
  const { isAuthenticated, login, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (isAuthenticated) {
      // Redirect to the page they were trying to access, or home
      // Check location.state first (from ProtectedRoute redirect)
      // Then check sessionStorage (from direct login)
      // Finally default to home
      const fromState = location.state as { from?: { pathname?: string } } | null;
      const fromPath = fromState?.from?.pathname || 
                       sessionStorage.getItem('keycloak_redirect_path') ||
                       localStorage.getItem('keycloak_redirect_path') || 
                       '/';
      sessionStorage.removeItem('keycloak_redirect_path');
      localStorage.removeItem('keycloak_redirect_path');
      navigate(fromPath, { replace: true });
    }
  }, [isAuthenticated, navigate, location]);

  const handleLogin = async () => {
    // Get redirect path from location.state (if redirected from ProtectedRoute)
    // or from sessionStorage (if set elsewhere)
    // or use current pathname if we're on a specific page
    const fromState = location.state as { from?: { pathname?: string; search?: string; hash?: string } } | null;
    let redirectPath = fromState?.from?.pathname || 
                       sessionStorage.getItem('keycloak_redirect_path') ||
                       (location.pathname !== '/login' ? location.pathname : undefined);
    
    // If we got pathname from state, also include search and hash if available
    if (fromState?.from?.pathname && !redirectPath?.includes('?')) {
      const search = fromState.from.search || '';
      const hash = fromState.from.hash || '';
      redirectPath = redirectPath + search + hash;
    }
    
    console.log('LoginPage: Redirect path to store:', redirectPath);
    console.log('LoginPage: location.state:', location.state);
    console.log('LoginPage: sessionStorage redirect path before login:', sessionStorage.getItem('keycloak_redirect_path'));
    
    // Always store the redirect path in both sessionStorage and localStorage
    // (localStorage persists better across redirects)
    if (redirectPath) {
      sessionStorage.setItem('keycloak_redirect_path', redirectPath);
      localStorage.setItem('keycloak_redirect_path', redirectPath);
    }
    
    await login(redirectPath);
  };

  if (loading) {
    return (
      <div className="login-page login-page--loading">
        <LoadingSpinner size="large" />
      </div>
    );
  }

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-logo">
          <BrandMark variant="login" />
        </div>
        <h1>Login to ITI</h1>
        <p>Please log in to create posts and interact with the community.</p>
        <button className="login-button" onClick={handleLogin}>
          Login with Keycloak
        </button>
      </div>
    </div>
  );
};

